/**
 * @generated SignedSource<<f86b09db91017f32cd61f406b4fae609>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "participativeModuleSlug"
},
v2 = [
  {
    "kind": "Variable",
    "name": "contributionSlug",
    "variableName": "contributionSlug"
  },
  {
    "kind": "Variable",
    "name": "participativeModuleSlug",
    "variableName": "participativeModuleSlug"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contributionsSubmissionAuthorized",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "required",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fieldName",
  "storageKey": null
},
v12 = [
  (v3/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "FormFieldOptionChoice",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isAnswerBase"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "values",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "other",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "formField",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v11/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hint",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hintPosition",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hide",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readOnly",
  "storageKey": null
},
v24 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "autoComplete",
    "storageKey": null
  }
],
v25 = {
  "kind": "InlineFragment",
  "selections": (v24/*: any*/),
  "type": "FormFieldString",
  "abstractKey": null
},
v26 = {
  "kind": "InlineFragment",
  "selections": (v24/*: any*/),
  "type": "FormFieldText",
  "abstractKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentAttachmentToken",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "FormFieldAuthorizations",
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displaySimilarContributionsSuggestions",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourcesAttachmentToken",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "sources",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    (v30/*: any*/),
    (v31/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "multiple",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxFiles",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowedFileExtensions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maximumFileSize",
      "storageKey": null
    }
  ],
  "type": "FormFieldFile",
  "abstractKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "otherValue",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayOtherField",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "otherFieldLabel",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singleOptionSelection",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maximumSelectableOptions",
  "storageKey": null
},
v39 = {
  "kind": "InlineFragment",
  "selections": [
    (v35/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selectableType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormFieldOptionChoice",
      "kind": "LinkedField",
      "name": "listedOptions",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v30/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCorrect",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correctionText",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionsSearchable",
      "storageKey": null
    }
  ],
  "type": "FormFieldCheckBoxes",
  "abstractKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "FormFieldOptionChoice",
  "kind": "LinkedField",
  "name": "selectedOptions",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v30/*: any*/)
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "AnswerWeightedOption",
  "kind": "LinkedField",
  "name": "dispatchedBudgetValues",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionId",
      "storageKey": null
    },
    (v41/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v3/*: any*/),
    (v30/*: any*/)
  ],
  "storageKey": null
},
v44 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budget",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxBudgetPerOption",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minBudgetToSpend",
      "storageKey": null
    },
    (v43/*: any*/)
  ],
  "type": "FormFieldBudgetDispatcher",
  "abstractKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectedThemeIds",
  "storageKey": null
},
v46 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maximumThemes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormFieldThemeOption",
      "kind": "LinkedField",
      "name": "themes",
      "plural": true,
      "selections": [
        (v19/*: any*/),
        (v41/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "FormFieldThemeOption",
          "kind": "LinkedField",
          "name": "children",
          "plural": true,
          "selections": [
            (v19/*: any*/),
            (v41/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "FormFieldThemeOption",
              "kind": "LinkedField",
              "name": "children",
              "plural": true,
              "selections": [
                (v19/*: any*/),
                (v41/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormFieldThemeOption",
                  "kind": "LinkedField",
                  "name": "children",
                  "plural": true,
                  "selections": [
                    (v19/*: any*/),
                    (v41/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FormFieldThemeOption",
                      "kind": "LinkedField",
                      "name": "children",
                      "plural": true,
                      "selections": [
                        (v19/*: any*/),
                        (v41/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FormFieldThemeOption",
                          "kind": "LinkedField",
                          "name": "children",
                          "plural": true,
                          "selections": [
                            (v19/*: any*/),
                            (v41/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FormFieldThemeOption",
                              "kind": "LinkedField",
                              "name": "children",
                              "plural": true,
                              "selections": [
                                (v19/*: any*/),
                                (v41/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "FormFieldThemeOption",
                                  "kind": "LinkedField",
                                  "name": "children",
                                  "plural": true,
                                  "selections": [
                                    (v19/*: any*/),
                                    (v41/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "FormFieldThemeOption",
                                      "kind": "LinkedField",
                                      "name": "children",
                                      "plural": true,
                                      "selections": [
                                        (v19/*: any*/),
                                        (v41/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "FormFieldThemeOption",
                                          "kind": "LinkedField",
                                          "name": "children",
                                          "plural": true,
                                          "selections": [
                                            (v19/*: any*/),
                                            (v41/*: any*/),
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "FormFieldThemeOption",
                                              "kind": "LinkedField",
                                              "name": "children",
                                              "plural": true,
                                              "selections": [
                                                (v19/*: any*/),
                                                (v41/*: any*/),
                                                (v3/*: any*/)
                                              ],
                                              "storageKey": null
                                            },
                                            (v3/*: any*/)
                                          ],
                                          "storageKey": null
                                        },
                                        (v3/*: any*/)
                                      ],
                                      "storageKey": null
                                    },
                                    (v3/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v3/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v3/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v3/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                },
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "FormFieldThemes",
  "abstractKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventIds",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "none",
  "storageKey": null
},
v49 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maximumEvents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowNone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "alias": "name",
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FormFieldEvents",
  "abstractKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "consentGiven",
  "storageKey": null
},
v51 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayEmailConsent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "consentLabel",
      "storageKey": null
    }
  ],
  "type": "FormFieldEmailWithConsents",
  "abstractKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "OralInterviewMessage",
  "kind": "LinkedField",
  "name": "messages",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v54 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closingMessage",
      "storageKey": null
    }
  ],
  "type": "FormFieldOralInterview",
  "abstractKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "individualSummary",
  "storageKey": null
},
v56 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minimumSelectableOptions",
      "storageKey": null
    },
    (v38/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v3/*: any*/),
        (v30/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "FormFieldSortableList",
  "abstractKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "AnswerItemOption",
  "kind": "LinkedField",
  "name": "itemOptions",
  "plural": true,
  "selections": [
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormFieldItem",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": (v12/*: any*/),
      "storageKey": null
    },
    (v13/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v58 = {
  "kind": "InlineFragment",
  "selections": [
    (v38/*: any*/),
    (v37/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormFieldItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v19/*: any*/)
      ],
      "storageKey": null
    },
    (v43/*: any*/)
  ],
  "type": "FormFieldMatrix",
  "abstractKey": null
},
v59 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v19/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerPresentationTitle",
  "abstractKey": null
},
v60 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v18/*: any*/)
          ],
          "type": "FormFieldPresentationTextZone",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerPresentationTextZone",
  "abstractKey": null
},
v61 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isMap"
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latitude",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longitude",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opacity",
  "storageKey": null
},
v67 = [
  (v31/*: any*/)
],
v68 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "iconClass",
        "storageKey": null
      },
      (v64/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contrastColor",
        "storageKey": null
      },
      (v65/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorOffsetX",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorOffsetY",
        "storageKey": null
      },
      (v66/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v67/*: any*/),
            "type": "Image",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v67/*: any*/),
            "type": "StaticImage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "MapElementImageStyle",
    "abstractKey": "__isMapElementImageStyle"
  },
  (v3/*: any*/)
],
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tileLayerUrl",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mapDataAttribution",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomLevelMin",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomLevelMax",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zIndexOffset",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementIconStyle",
  "kind": "LinkedField",
  "name": "iconStyle",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementBackgroundStyle",
  "kind": "LinkedField",
  "name": "backgroundStyle",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": null
},
v76 = [
  (v74/*: any*/),
  (v75/*: any*/)
],
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementPointStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": [
    (v73/*: any*/),
    (v74/*: any*/),
    (v75/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MapElementZoomLevelStyle",
      "kind": "LinkedField",
      "name": "zoomLevels",
      "plural": true,
      "selections": [
        (v71/*: any*/),
        (v72/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v76/*: any*/),
              "type": "MapElementPointStyle",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v76/*: any*/),
              "type": "MapElementCompoundFeatureStyle",
              "abstractKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterElementsOutOnInitialize",
  "storageKey": null
},
v79 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "style",
  "storageKey": null
},
v81 = [
  (v64/*: any*/),
  (v66/*: any*/),
  (v80/*: any*/),
  (v65/*: any*/),
  (v73/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "MapElementZoomLevelStyle",
    "kind": "LinkedField",
    "name": "zoomLevels",
    "plural": true,
    "selections": [
      (v71/*: any*/),
      (v72/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "style",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v64/*: any*/),
              (v66/*: any*/),
              (v80/*: any*/),
              (v65/*: any*/),
              (v73/*: any*/)
            ],
            "type": "MapElementPathStyle",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "storageKey": null
  },
  (v3/*: any*/)
],
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "MapElementPathStyle",
  "kind": "LinkedField",
  "name": "borderStyle",
  "plural": false,
  "selections": (v81/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContributionEditRouteQuery",
    "selections": [
      {
        "alias": "contribution",
        "args": (v2/*: any*/),
        "concreteType": "Contribution",
        "kind": "LinkedField",
        "name": "editContribution",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContributionForm_contribution"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContributionEditRouteQuery",
    "selections": [
      {
        "alias": "contribution",
        "args": (v2/*: any*/),
        "concreteType": "Contribution",
        "kind": "LinkedField",
        "name": "editContribution",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDraft",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formHash",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentPage",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isCorrection",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "correctionTextOnlyOnWrongAnswers",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContributionAuthorizations",
            "kind": "LinkedField",
            "name": "authorizations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "toggleAnonymousMode",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "validateContribution",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editContribution",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formStepBack",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayStepsProgression",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ParticipativeModule",
            "kind": "LinkedField",
            "name": "participativeModule",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "disclaimer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "completeMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModuleAuthorizations",
                "kind": "LinkedField",
                "name": "authorizations",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ParticipativeModuleAuthorizationsUnauthorizedMessages",
                    "kind": "LinkedField",
                    "name": "unauthorizedMessages",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "visualization",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "path",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              (v8/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fromAnonymous",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "answers",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "formField",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v10/*: any*/),
                  (v3/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormFieldDisplayCondition",
                    "kind": "LinkedField",
                    "name": "displayConditions",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formFieldName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormFieldDisplayConditionOption",
                        "kind": "LinkedField",
                        "name": "conditionOptions",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "otherOption",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v14/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSeparator",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "displayConditionAnswers",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "AnswerString",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "AnswerText",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v18/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "AnswerRichText",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v29/*: any*/),
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "AnswerFile",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v34/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v39/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v40/*: any*/)
                ],
                "type": "AnswerCheckBoxes",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v42/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v44/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "AnswerBudgetDispatcher",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v45/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v46/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "AnswerThemes",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v47/*: any*/),
                  (v48/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v49/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "AnswerEvents",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v18/*: any*/),
                  (v50/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v51/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "AnswerEmailWithConsents",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v18/*: any*/),
                  (v52/*: any*/),
                  (v53/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v22/*: any*/),
                      (v20/*: any*/),
                      (v54/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v55/*: any*/)
                ],
                "type": "AnswerOralInterview",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v56/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "AnswerSortableList",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v16/*: any*/),
                  (v34/*: any*/),
                  (v57/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v58/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "AnswerMatrix",
                "abstractKey": null
              },
              (v59/*: any*/),
              (v60/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "answers",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v3/*: any*/),
                      (v17/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v10/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v25/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AnswerString",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v10/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v26/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AnswerText",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          (v27/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v10/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v28/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AnswerRichText",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v29/*: any*/),
                          (v32/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v10/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v33/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AnswerFile",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v34/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v10/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v39/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v40/*: any*/)
                        ],
                        "type": "AnswerCheckBoxes",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v42/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v10/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v44/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AnswerBudgetDispatcher",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v45/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v10/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v46/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AnswerThemes",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v47/*: any*/),
                          (v48/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v10/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v49/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AnswerEvents",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          (v50/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v10/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v51/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AnswerEmailWithConsents",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v10/*: any*/),
                              (v22/*: any*/),
                              (v20/*: any*/),
                              (v54/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v55/*: any*/)
                        ],
                        "type": "AnswerOralInterview",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v10/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v56/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AnswerSortableList",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          (v34/*: any*/),
                          (v57/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v10/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v58/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AnswerMatrix",
                        "abstractKey": null
                      },
                      (v59/*: any*/),
                      (v60/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "AnswerAddress",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "goal",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unit",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "maxAmount",
                            "storageKey": null
                          }
                        ],
                        "type": "FormFieldBudget",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AnswerBudgetChapter",
                    "kind": "LinkedField",
                    "name": "answers",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v11/*: any*/),
                          (v3/*: any*/),
                          (v19/*: any*/),
                          (v10/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormFieldOptionBudgetLine",
                                "kind": "LinkedField",
                                "name": "budgetLines",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v30/*: any*/),
                                  (v41/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "withOptions",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayMode",
                                    "storageKey": null
                                  },
                                  (v38/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BudgetLineOption",
                                    "kind": "LinkedField",
                                    "name": "budgetLineOptions",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v19/*: any*/),
                                      (v41/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "position",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "FormFieldBudgetChapter",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "AnswerBudget",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "finalizeUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasPreviousPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "contribuable",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "visualization",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v3/*: any*/),
                      (v61/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "ParticipativeModule",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasLocation",
            "storageKey": null
          },
          (v62/*: any*/),
          (v63/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MapElementThemeStyle",
                "kind": "LinkedField",
                "name": "style",
                "plural": false,
                "selections": (v68/*: any*/),
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "map",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v61/*: any*/),
              (v8/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MapElementThemeStyle",
                    "kind": "LinkedField",
                    "name": "newContributionMarkerStyle",
                    "plural": false,
                    "selections": (v68/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "zoomDefault",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "zoomMin",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "zoomMax",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mobileZoomDefault",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mobileZoomMin",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mobileZoomMax",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "centerLatitude",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "centerLongitude",
                        "storageKey": null
                      },
                      (v69/*: any*/),
                      (v70/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MapZoomLevelConfiguration",
                        "kind": "LinkedField",
                        "name": "zoomLevels",
                        "plural": true,
                        "selections": [
                          (v71/*: any*/),
                          (v72/*: any*/),
                          (v69/*: any*/),
                          (v70/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasElements",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "vectorTileUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "markersMaxClusterRadius",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MapElementPoint",
                        "kind": "LinkedField",
                        "name": "clusterizedPoints",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasInformationWindow",
                            "storageKey": null
                          },
                          (v62/*: any*/),
                          (v63/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mapElementGeometryId",
                            "storageKey": null
                          },
                          (v77/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MapElementTooltip",
                            "kind": "LinkedField",
                            "name": "tooltip",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MapFilterList",
                        "kind": "LinkedField",
                        "name": "filterLists",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "filters",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v78/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MapTaxonomy",
                                    "kind": "LinkedField",
                                    "name": "mapTaxonomies",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MapTaxonomy",
                                        "kind": "LinkedField",
                                        "name": "children",
                                        "plural": true,
                                        "selections": (v12/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "MapFilterTaxonomy",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v78/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "mapElements",
                                    "plural": true,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "MapFilterElement",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v79/*: any*/),
                        "concreteType": "MapElementConnection",
                        "kind": "LinkedField",
                        "name": "elements",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MapElementEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MapTaxonomy",
                                    "kind": "LinkedField",
                                    "name": "mapTaxonomies",
                                    "plural": true,
                                    "selections": (v12/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isMapElement"
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "geometriesType",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MapElementCompoundFeatureStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": [
                                          (v73/*: any*/),
                                          (v74/*: any*/),
                                          (v82/*: any*/),
                                          (v75/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "MapElementShadowStyle",
                                            "kind": "LinkedField",
                                            "name": "shadowStyle",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "offsetX",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "offsetY",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "blur",
                                                "storageKey": null
                                              },
                                              (v64/*: any*/),
                                              (v66/*: any*/),
                                              (v3/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "MapElementZoomLevelStyle",
                                            "kind": "LinkedField",
                                            "name": "zoomLevels",
                                            "plural": true,
                                            "selections": [
                                              (v71/*: any*/),
                                              (v72/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "style",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v74/*: any*/)
                                                    ],
                                                    "type": "MapElementCompoundFeatureStyle",
                                                    "abstractKey": null
                                                  },
                                                  (v3/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v3/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "MapElementCompoundFeature",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MapElementPathStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": (v81/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "MapElementPath",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v77/*: any*/)
                                    ],
                                    "type": "MapElementPoint",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MapElementShapeStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": [
                                          (v73/*: any*/),
                                          (v82/*: any*/),
                                          (v75/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "MapElementZoomLevelStyle",
                                            "kind": "LinkedField",
                                            "name": "zoomLevels",
                                            "plural": true,
                                            "selections": [
                                              (v71/*: any*/),
                                              (v72/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "style",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v82/*: any*/),
                                                      (v75/*: any*/)
                                                    ],
                                                    "type": "MapElementShapeStyle",
                                                    "abstractKey": null
                                                  },
                                                  (v3/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v3/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "MapElementShape",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "elements(first:2147483647)"
                      },
                      {
                        "alias": null,
                        "args": (v79/*: any*/),
                        "filters": null,
                        "handle": "connection",
                        "key": "MapElements_elements",
                        "kind": "LinkedHandle",
                        "name": "elements"
                      }
                    ],
                    "type": "Map",
                    "abstractKey": "__isMap"
                  }
                ],
                "type": "ContributionsMap",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stepIndex",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stepsTotal",
                "storageKey": null
              }
            ],
            "type": "FormAnswerInterface",
            "abstractKey": "__isFormAnswerInterface"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "forceAnonymousContributions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "authorizations",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "WithAnonymousMode",
            "abstractKey": "__isWithAnonymousMode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a3ce0c44ebb3aa43c2188a16b6d7f39c",
    "id": null,
    "metadata": {},
    "name": "ContributionEditRouteQuery",
    "operationKind": "query",
    "text": "query ContributionEditRouteQuery(\n  $participativeModuleSlug: ID!\n  $contributionSlug: ID!\n) {\n  contribution: editContribution(participativeModuleSlug: $participativeModuleSlug, contributionSlug: $contributionSlug) {\n    ...ContributionForm_contribution\n    id\n  }\n}\n\nfragment AnonymousContributionFormBanner_anonymousMode on WithAnonymousMode {\n  __isWithAnonymousMode: __typename\n  forceAnonymousContributions\n  authorizations {\n    __typename\n    toggleAnonymousMode\n    id\n  }\n}\n\nfragment AnswerAddress_answer on AnswerAddress {\n  formField {\n    __typename\n    id\n    fieldName\n    hide\n  }\n  answers {\n    __typename\n    id\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    ...ShallowAnswer_answer\n  }\n}\n\nfragment AnswerBudgetChapter_answer on AnswerBudgetChapter {\n  values\n  formField {\n    __typename\n    fieldName\n    label\n    required\n    hint\n    hintPosition\n    hide\n    ... on FormFieldBudgetChapter {\n      budgetLines {\n        id\n        name\n        value\n        withOptions\n        displayMode\n        maximumSelectableOptions\n        description\n        budgetLineOptions {\n          id\n          label\n          value\n          position\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AnswerBudgetDispatcher_answer on AnswerBudgetDispatcher {\n  id\n  dispatchedBudgetValues {\n    optionId\n    value\n    id\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldBudgetDispatcher {\n      budget\n      maxBudgetPerOption\n      minBudgetToSpend\n      options {\n        __typename\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment AnswerBudget_answer on AnswerBudget {\n  formField {\n    __typename\n    fieldName\n    label\n    required\n    hint\n    hintPosition\n    hide\n    ... on FormFieldBudget {\n      goal\n      unit\n      minAmount\n      maxAmount\n    }\n    id\n  }\n  answers {\n    id\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    ...AnswerBudgetChapter_answer\n  }\n}\n\nfragment AnswerCheckBoxes_answer on AnswerCheckBoxes {\n  values\n  other\n  otherValue\n  formField {\n    __typename\n    id\n    fieldName\n    label\n    required\n    hint\n    hintPosition\n    hide\n    ... on FormFieldCheckBoxes {\n      displayOtherField\n      otherFieldLabel\n      singleOptionSelection\n      maximumSelectableOptions\n      selectableType\n      listedOptions {\n        id\n        name\n        isCorrect\n        correctionText\n      }\n    }\n  }\n  ...FormFieldOptionsSelect_answer\n}\n\nfragment AnswerEmailWithConsents_answer on AnswerEmailWithConsents {\n  id\n  content\n  consentGiven\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldEmailWithConsents {\n      displayEmailConsent\n      consentLabel\n    }\n  }\n}\n\nfragment AnswerEvents_answer on AnswerEvents {\n  id\n  eventIds\n  none\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldEvents {\n      maximumEvents\n      allowNone\n      options {\n        id\n        name: title\n      }\n    }\n  }\n}\n\nfragment AnswerFile_answer on AnswerFile {\n  sourcesAttachmentToken\n  sources {\n    key\n    name\n    url\n    id\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldFile {\n      multiple\n      maxFiles\n      allowedFileExtensions\n      maximumFileSize\n    }\n  }\n}\n\nfragment AnswerMatrix_answer on AnswerMatrix {\n  id\n  other\n  otherValue\n  itemOptions {\n    other\n    item {\n      id\n    }\n    option {\n      id\n    }\n    id\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldMatrix {\n      maximumSelectableOptions\n      singleOptionSelection\n      displayOtherField\n      otherFieldLabel\n      items {\n        id\n        label\n      }\n      options {\n        __typename\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment AnswerOralInterview_answer on AnswerOralInterview {\n  content\n  status\n  messages {\n    role\n    text\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    fieldName\n    hide\n  }\n  ...InterviewChatSection_answer\n  ...InterviewCompletionSection_answer\n  ...InterviewControlsSection_answer\n  ...InterviewIntroSection_answer\n  ...InterviewResponseSection_answer\n}\n\nfragment AnswerPresentationTextZone_answer on AnswerPresentationTextZone {\n  formField {\n    __typename\n    ... on FormFieldPresentationTextZone {\n      content\n    }\n    id\n  }\n}\n\nfragment AnswerPresentationTitle_answer on AnswerPresentationTitle {\n  formField {\n    __typename\n    label\n    id\n  }\n}\n\nfragment AnswerRichText_answer on AnswerRichText {\n  id\n  content\n  contentAttachmentToken\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    readOnly\n    id\n  }\n  ...SimilarAnswersSuggestions_answer\n}\n\nfragment AnswerSortableList_answer on AnswerSortableList {\n  id\n  values\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldSortableList {\n      minimumSelectableOptions\n      maximumSelectableOptions\n      options {\n        __typename\n        id\n        name\n        description\n      }\n    }\n  }\n}\n\nfragment AnswerString_answer on AnswerString {\n  content\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    readOnly\n    ... on FormFieldString {\n      autoComplete\n    }\n    id\n  }\n}\n\nfragment AnswerText_answer on AnswerText {\n  content\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    readOnly\n    ... on FormFieldText {\n      autoComplete\n    }\n    id\n  }\n}\n\nfragment AnswerThemes_answer on AnswerThemes {\n  selectedThemeIds\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldThemes {\n      maximumThemes\n      themes {\n        label\n        value\n        children {\n          label\n          value\n          children {\n            label\n            value\n            children {\n              label\n              value\n              children {\n                label\n                value\n                children {\n                  label\n                  value\n                  children {\n                    label\n                    value\n                    children {\n                      label\n                      value\n                      children {\n                        label\n                        value\n                        children {\n                          label\n                          value\n                          children {\n                            label\n                            value\n                            id\n                          }\n                          id\n                        }\n                        id\n                      }\n                      id\n                    }\n                    id\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment Answer_answer on AnswerBase {\n  __isAnswerBase: __typename\n  __typename\n  ...ShallowAnswer_answer\n  ...AnswerAddress_answer\n  ...AnswerBudget_answer\n  ...useAnswerShouldBeConditionnallyHidden_answer\n}\n\nfragment Answers_answers on AnswerBase {\n  __isAnswerBase: __typename\n  id\n  isSeparator\n  ...Answer_answer\n  ...useFilterConditionnallyHiddenAnswers_answers\n}\n\nfragment ContributionFormModalTitle_contribution on Contribution {\n  id\n  authorizations {\n    formStepBack\n    displayStepsProgression\n    id\n  }\n  ... on FormAnswerInterface {\n    __isFormAnswerInterface: __typename\n    stepIndex\n    stepsTotal\n    hasPreviousPage\n  }\n}\n\nfragment ContributionForm_contribution on Contribution {\n  id\n  isDraft\n  formHash\n  currentPage {\n    __typename\n    id\n  }\n  authorizations {\n    toggleAnonymousMode\n    id\n  }\n  participativeModule {\n    disclaimer\n    completeMessage\n    authorizations {\n      contributionsSubmissionAuthorized\n      unauthorizedMessages {\n        contributionsSubmissionAuthorized\n      }\n    }\n    visualization {\n      __typename\n      path\n      id\n    }\n    id\n  }\n  ...FormDisclaimer_contribution\n  ...FormPage_contribution\n  ...FormComplete_contribution\n}\n\nfragment ContributionLocationMap_contribution on Contribution {\n  hasLocation\n  latitude\n  longitude\n  theme {\n    style {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  map {\n    __typename\n    ... on ContributionsMap {\n      newContributionMarkerStyle {\n        ... on MapElementImageStyle {\n          __isMapElementImageStyle: __typename\n          iconClass\n          color\n          contrastColor\n          width\n          height\n          anchor\n          anchorOffsetX\n          anchorOffsetY\n          opacity\n          image {\n            __typename\n            ... on Image {\n              url\n            }\n            ... on StaticImage {\n              url\n            }\n          }\n        }\n        id\n      }\n      ...MapBase_map\n    }\n    ...MapContextProvider_map\n    id\n  }\n}\n\nfragment FormComplete_contribution on Contribution {\n  participativeModule {\n    slug\n    title\n    completeMessage\n    id\n  }\n  ...ContributionFormModalTitle_contribution\n}\n\nfragment FormDisclaimer_contribution on Contribution {\n  authorizations {\n    toggleAnonymousMode\n    id\n  }\n  participativeModule {\n    id\n    slug\n    title\n    disclaimer\n  }\n}\n\nfragment FormFieldOptionsSelect_answer on AnswerCheckBoxes {\n  selectedOptions {\n    id\n    name\n  }\n  formField {\n    __typename\n    id\n    ... on FormFieldCheckBoxes {\n      optionsSearchable\n    }\n  }\n}\n\nfragment FormPage_contribution on Contribution {\n  id\n  isDraft\n  hasNextPage\n  fromAnonymous\n  answers {\n    __typename\n    formField {\n      __typename\n      required\n      id\n    }\n    ...Answers_answers\n    id\n  }\n  finalizeUrl\n  currentPage {\n    __typename\n    id\n    title\n    description\n    isCorrection\n    correctionTextOnlyOnWrongAnswers\n  }\n  hasPreviousPage\n  authorizations {\n    validateContribution\n    editContribution\n    formStepBack\n    id\n  }\n  contribuable {\n    __typename\n    id\n    ... on ParticipativeModule {\n      visualization {\n        __typename\n        ... on Map {\n          __isMap: __typename\n          id\n        }\n        id\n      }\n    }\n  }\n  ...ContributionFormModalTitle_contribution\n  ...ContributionLocationMap_contribution\n  ...AnonymousContributionFormBanner_anonymousMode\n}\n\nfragment InterviewChatMessage_message on OralInterviewMessage {\n  role\n  text\n}\n\nfragment InterviewChatSection_answer on AnswerOralInterview {\n  messages {\n    ...InterviewChatMessage_message\n  }\n}\n\nfragment InterviewCompletionSection_answer on AnswerOralInterview {\n  individualSummary\n  formField {\n    __typename\n    ... on FormFieldOralInterview {\n      closingMessage\n    }\n    id\n  }\n}\n\nfragment InterviewControlsSection_answer on AnswerOralInterview {\n  status\n  messages {\n    role\n    text\n  }\n  formField {\n    __typename\n    id\n    required\n  }\n}\n\nfragment InterviewIntroSection_answer on AnswerOralInterview {\n  formField {\n    __typename\n    hint\n    id\n  }\n}\n\nfragment InterviewResponseSection_answer on AnswerOralInterview {\n  status\n  formField {\n    __typename\n    id\n  }\n}\n\nfragment MapBase_map on Map {\n  __isMap: __typename\n  id\n  zoomDefault\n  zoomMin\n  zoomMax\n  mobileZoomDefault\n  mobileZoomMin\n  mobileZoomMax\n  centerLatitude\n  centerLongitude\n  tileLayerUrl\n  mapDataAttribution\n  zoomLevels {\n    zoomLevelMin\n    zoomLevelMax\n    tileLayerUrl\n    mapDataAttribution\n    id\n  }\n  ...MapElementsVectorGrid_map\n}\n\nfragment MapClusterizedPointMarker_point on MapElementPoint {\n  id\n  hasInformationWindow\n  latitude\n  longitude\n  mapElementGeometryId\n  style {\n    zIndexOffset\n    iconStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    backgroundStyle {\n      ... on MapElementImageStyle {\n        __isMapElementImageStyle: __typename\n        iconClass\n        color\n        contrastColor\n        width\n        height\n        anchor\n        anchorOffsetX\n        anchorOffsetY\n        opacity\n        image {\n          __typename\n          ... on Image {\n            url\n          }\n          ... on StaticImage {\n            url\n          }\n        }\n      }\n      id\n    }\n    zoomLevels {\n      zoomLevelMin\n      zoomLevelMax\n      style {\n        __typename\n        ... on MapElementPointStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        ... on MapElementCompoundFeatureStyle {\n          iconStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n          backgroundStyle {\n            ... on MapElementImageStyle {\n              __isMapElementImageStyle: __typename\n              iconClass\n              color\n              contrastColor\n              width\n              height\n              anchor\n              anchorOffsetX\n              anchorOffsetY\n              opacity\n              image {\n                __typename\n                ... on Image {\n                  url\n                }\n                ... on StaticImage {\n                  url\n                }\n              }\n            }\n            id\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  tooltip {\n    ...MapElementTooltip_tooltip\n    id\n  }\n}\n\nfragment MapClusterizedPointMarkers_map on Map {\n  __isMap: __typename\n  markersMaxClusterRadius\n  clusterizedPoints {\n    id\n    ...MapClusterizedPointMarker_point\n  }\n  ...useMapElementsFilteredIn_map\n}\n\nfragment MapContextProvider_map on Map {\n  __isMap: __typename\n  __typename\n  slug\n}\n\nfragment MapElementTooltip_tooltip on MapElementTooltip {\n  content\n}\n\nfragment MapElementsVectorGridTileLayerStyles_map on Map {\n  __isMap: __typename\n  elements(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        __isMapElement: __typename\n        id\n        geometriesType\n        ... on MapElementCompoundFeature {\n          style {\n            zIndexOffset\n            iconStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            borderStyle {\n              color\n              opacity\n              style\n              width\n              zIndexOffset\n              zoomLevels {\n                zoomLevelMin\n                zoomLevelMax\n                style {\n                  __typename\n                  ... on MapElementPathStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            shadowStyle {\n              offsetX\n              offsetY\n              blur\n              color\n              opacity\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementCompoundFeatureStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementPath {\n          style {\n            color\n            opacity\n            style\n            width\n            zIndexOffset\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementPathStyle {\n                  color\n                  opacity\n                  style\n                  width\n                  zIndexOffset\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementPoint {\n          style {\n            zIndexOffset\n            iconStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementPointStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                ... on MapElementCompoundFeatureStyle {\n                  iconStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n        ... on MapElementShape {\n          style {\n            zIndexOffset\n            borderStyle {\n              color\n              opacity\n              style\n              width\n              zIndexOffset\n              zoomLevels {\n                zoomLevelMin\n                zoomLevelMax\n                style {\n                  __typename\n                  ... on MapElementPathStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            backgroundStyle {\n              ... on MapElementImageStyle {\n                __isMapElementImageStyle: __typename\n                iconClass\n                color\n                contrastColor\n                width\n                height\n                anchor\n                anchorOffsetX\n                anchorOffsetY\n                opacity\n                image {\n                  __typename\n                  ... on Image {\n                    url\n                  }\n                  ... on StaticImage {\n                    url\n                  }\n                }\n              }\n              id\n            }\n            zoomLevels {\n              zoomLevelMin\n              zoomLevelMax\n              style {\n                __typename\n                ... on MapElementShapeStyle {\n                  borderStyle {\n                    color\n                    opacity\n                    style\n                    width\n                    zIndexOffset\n                    zoomLevels {\n                      zoomLevelMin\n                      zoomLevelMax\n                      style {\n                        __typename\n                        ... on MapElementPathStyle {\n                          color\n                          opacity\n                          style\n                          width\n                          zIndexOffset\n                        }\n                        id\n                      }\n                      id\n                    }\n                    id\n                  }\n                  backgroundStyle {\n                    ... on MapElementImageStyle {\n                      __isMapElementImageStyle: __typename\n                      iconClass\n                      color\n                      contrastColor\n                      width\n                      height\n                      anchor\n                      anchorOffsetX\n                      anchorOffsetY\n                      opacity\n                      image {\n                        __typename\n                        ... on Image {\n                          url\n                        }\n                        ... on StaticImage {\n                          url\n                        }\n                      }\n                    }\n                    id\n                  }\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...useMapElementsFilteredIn_map\n}\n\nfragment MapElementsVectorGrid_map on Map {\n  __isMap: __typename\n  id\n  hasElements\n  vectorTileUrl\n  ...MapClusterizedPointMarkers_map\n  ...MapElementsVectorGridTileLayerStyles_map\n}\n\nfragment ShallowAnswer_answer on AnswerBase {\n  __isAnswerBase: __typename\n  __typename\n  ...AnswerString_answer\n  ...AnswerText_answer\n  ...AnswerRichText_answer\n  ...AnswerFile_answer\n  ...AnswerCheckBoxes_answer\n  ...AnswerBudgetDispatcher_answer\n  ...AnswerThemes_answer\n  ...AnswerEvents_answer\n  ...AnswerEmailWithConsents_answer\n  ...AnswerOralInterview_answer\n  ...AnswerSortableList_answer\n  ...AnswerMatrix_answer\n  ...AnswerPresentationTitle_answer\n  ...AnswerPresentationTextZone_answer\n}\n\nfragment SimilarAnswersSuggestions_answer on AnswerRichText {\n  ...useSimilarAnswers_answer\n}\n\nfragment useAnswerShouldBeConditionnallyHidden_answer on AnswerBase {\n  __isAnswerBase: __typename\n  formField {\n    __typename\n    fieldName\n    displayConditions {\n      formFieldName\n      conditionOptions {\n        otherOption\n        option {\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  displayConditionAnswers {\n    __typename\n    values\n    other\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    id\n  }\n}\n\nfragment useFilterConditionnallyHiddenAnswers_answers on AnswerBase {\n  __isAnswerBase: __typename\n  id\n  formField {\n    __typename\n    fieldName\n    displayConditions {\n      formFieldName\n      conditionOptions {\n        otherOption\n        option {\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  displayConditionAnswers {\n    __typename\n    values\n    other\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    id\n  }\n}\n\nfragment useMapElementsFilteredIn_map on Map {\n  __isMap: __typename\n  id\n  filterLists {\n    filters {\n      __typename\n      id\n      ... on MapFilterTaxonomy {\n        filterElementsOutOnInitialize\n        mapTaxonomies {\n          id\n          children {\n            id\n          }\n        }\n      }\n      ... on MapFilterElement {\n        filterElementsOutOnInitialize\n        mapElements {\n          __typename\n          id\n        }\n      }\n    }\n    id\n  }\n  elements(first: 2147483647) {\n    edges {\n      node {\n        __typename\n        id\n        mapTaxonomies {\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useSimilarAnswers_answer on AnswerRichText {\n  id\n  formField {\n    __typename\n    id\n    authorizations {\n      displaySimilarContributionsSuggestions\n    }\n  }\n}\n"
  }
};
})();

node.hash = "74d26c66a83991a0d2000466411b7dbe";

module.exports = node;
